module.exports = __webpack_public_path__ + "img/logo-blue.6b519343.png";